<div class="wrapper">
  <app-property-share-buyers-list
    [propertyId]="propertyId"
    [showCloseButton]="true"
    (handleClose)="handleClose.emit()"
    type="SMS"
  ></app-property-share-buyers-list>
</div>
